import { SAVE_PARENT_LOCATION } from '../../../ActionsConst';

export const saveParentLocationAction = (parentLocation: string) => ({
  type: SAVE_PARENT_LOCATION,
  parentLocation,
});
